import { nothing } from 'lit'
import { html, literal, unsafeStatic } from 'lit/static-html.js'
import { ApiBlockGridItemModel, ApiBlockItemModel, BlockSettingsPropertiesModel, IApiMediaWithCropsModel } from './api/ContentDeliveryApi.schemas'
import type { UmbracoPage } from './ContentLoader'

export const renderGridElement = (item: ApiBlockGridItemModel, root: UmbracoPage) => {
	const styles: string[] = []

	// console.log(item.settings as BlockSettingsPropertiesModel)

	if (item.rowSpan && item.columnSpan) {
		styles.push(`--row-span:${item.rowSpan}`, `--column-span:${item.columnSpan}`)
	}

	if (item.settings?.properties.textPosition) {
		const [vertical, horizontal] = (item.settings.properties.textPosition as string).split(' ')
		styles.push(`text-align: ${horizontal}`)
		styles.push(`align-self: ${vertical.replace('middle', 'center').replace('top', 'start').replace('bottom', 'end')}`)
	}

	return renderElement(item, root, styles)
}

export const renderElement = (item: ApiBlockItemModel | ApiBlockGridItemModel, root: UmbracoPage, styles: string[] = []) => {
	if (item.content.contentType == 'grid') styles.push(`--columns:${item.content.properties?.items['gridColumns']}`)

	const settings = item.settings?.properties as BlockSettingsPropertiesModel
	if (settings?.colorScheme) styles.push(`color-scheme: ${settings.colorScheme}`)
	if (settings?.['backgroundStyle']) styles.push(`background: ${settings['backgroundStyle']}`)

	const tag = literal`lindberg-${unsafeStatic(item.content.contentType.split(/(?=[A-Z])/).join('-').toLowerCase())}`
	return html`<${tag} style=${styles.join('; ')} .data=${item} .root=${root}></${tag}>`
	
}

export const renderMedia = (media: IApiMediaWithCropsModel[], settings:any, mobileMedia?: IApiMediaWithCropsModel[]) => {
	return html`
		${media.map(m => renderMediaElement(m, settings, mobileMedia?.length ?  "desktop-only" : ''))}
		${mobileMedia?.map(m => renderMediaElement(m, settings, 'mobile-only'))}
	`
}

const renderMediaElement = (media:IApiMediaWithCropsModel, settings:any, className: string = '') => {
	if (media.mediaType == 'Image') {
		return html`<lindberg-image .data=${media} .settings=${settings} class=${className || nothing}></lindberg-image>`
	} else if (media.mediaType == 'umbracoMediaVideo') {
		return html`<lindberg-video .data=${media} .settings=${settings} class=${className || nothing}></lindberg-video>`
	} else {
		return html`<h2>unknown ${media.mediaType}</h2>`
	}
}
